import { useState } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import {
  devicesActions, geofencesActions, groupsActions, maintenancesActions,
} from './store';
import { useEffectAsync } from './reactHelper';
import { fetchAndDecode, fetchMsgPack } from './common/util/utils';

const CachingController = () => {
  const authenticated = useSelector((state) => !!state.session.user);
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const [devicesLoaded, setDevicesLoaded] = useState(false);

  // The main page draws itself from the tiered endpoints and never needs the
  // whole fleet. The reports and settings screens still pick devices from
  // the store, so the full list is fetched once, the first time one of them
  // opens. Converting those screens is the next step; this keeps them
  // working meanwhile.
  useEffectAsync(async () => {
    if (authenticated && !devicesLoaded && pathname !== '/') {
      const devices = await fetchMsgPack('/api/devices');
      dispatch(devicesActions.update(devices));
      setDevicesLoaded(true);
    }
  }, [authenticated, devicesLoaded, pathname]);

  useEffectAsync(async () => {
    if (authenticated) {
      const geofences = await fetchAndDecode('/api/geofences?includeLinks=true');
      dispatch(geofencesActions.update(geofences));
    }
  }, [authenticated]);

  useEffectAsync(async () => {
    if (authenticated) {
      const groups = await fetchAndDecode('/api/groups');
      dispatch(groupsActions.update(groups));
    }
  }, [authenticated]);

  useEffectAsync(async () => {
    if (authenticated) {
      const maintenance = await fetchAndDecode('/api/maintenance');
      dispatch(maintenancesActions.update(maintenance));
    }
  }, [authenticated]);

  return null;
};

export default connect()(CachingController);
